import React, { useState } from "react";
import { Descriptions, Space, Button, Result } from "antd";
import { PaperClipOutlined } from "@ant-design/icons";
import { RowData } from "../data-transfer";
import { useNavigate } from "react-router-dom";
import { environmentNames } from "./constants";
import { hasCheckedDeliverable } from "./utils";

interface DataUploadReviewProps {
  formValues: any;
  handleEdit: () => void;
  data: RowData;
  userEmail: string | null;
  fileNames: string[];
  handleReview: (isDraft: boolean) => void;
  submitPage: boolean;
  loadingSubmit: boolean;
  zipContentPreview: string[];
}

export interface DeliverableItem {
  checked: boolean;
  comment: string;
}

const DataUploadReview: React.FC<DataUploadReviewProps> = ({
  formValues,
  handleEdit,
  data,
  userEmail,
  fileNames,
  handleReview,
  submitPage,
  loadingSubmit,
  zipContentPreview,
}) => {
  const [formData] = useState(formValues);
  const navigate = useNavigate();
  const environment = formData.transferLocation;
  const checkedDeliverable = hasCheckedDeliverable(formData.SDTMDeliverables);

  const handleSubmit = () => {
    handleReview(false);
  };

  const items = [
    {
      label: "Transfer Type",
      children: formData.transferId,
    },
    {
      label: "Transfer Location",
      children: environmentNames[environment],
    },
    {
      label: "File(s)",
      children: formData.fileInput.length ? (
        formData.fileInput.map((file: any) => (
          <div key={file.name}>
            <PaperClipOutlined />{" "}
            <span style={{ color: "#008576" }}>{file.name}</span>
          </div>
        ))
      ) : (
        <div>File is not available</div>
      ),
    },
    {
      label: "File Contents",
      children:
        zipContentPreview?.length > 0 ? (
          zipContentPreview.map((file: any) => (
            <div key={file}>
              <span style={{ color: "#008576" }}>{file}</span>
            </div>
          ))
        ) : (
          <div>preview files are not available</div>
        ),
    },
    {
      label: "Description",
      children: formData.description,
    },
  ];

  return (
    <div
      style={{
        backgroundColor: "white",
        padding: "30px",
        minHeight: "23.5rem",
      }}
    >
      {!submitPage ? (
        <>
          <Descriptions
            size="small"
            bordered
            column={1}
            items={items}
            title={
              <div style={{ fontSize: "1.2rem", fontWeight: "normal" }}>
                Review
              </div>
            }
          />

          {checkedDeliverable && (
            <Descriptions
              title="Transfer Deliverables"
              bordered
              column={1}
              style={{ marginTop: "20px" }}
            >
              {(
                Object.entries(formData.SDTMDeliverables) as [
                  string,
                  DeliverableItem,
                ][]
              )
                .filter(([_, value]) => value.checked)
                .map(([key, value]) => (
                  <Descriptions.Item key={value.comment} label={key}>
                    {value.comment}
                  </Descriptions.Item>
                ))}
            </Descriptions>
          )}

          <Space style={{ marginTop: "2rem" }}>
            <Button
              color="cyan"
              variant="solid"
              onClick={handleSubmit}
              loading={loadingSubmit}
            >
              {" "}
              Submit
            </Button>
            <Button variant="outlined"
              onClick={handleEdit}
              disabled={loadingSubmit}>
              {" "}
              Edit
            </Button>
          </Space>
        </>
      ) : (
        <div>
          <Result
            status="success"
            title="Upload Complete"
            subTitle="Your data has been uploaded"
            extra={[
              <Button
                type="primary"
                key="buy"
                className="primary"
                onClick={() => navigate("/dashboard")}
              >
                {" "}
                My Dashboard{" "}
              </Button>,
            ]}
          />
        </div>
      )}
    </div>
  );
};

export default DataUploadReview;
